import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    constructor(
        private titleService: Title,
        private meta: Meta,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private doc: Document
    )
    {
        this.titleService.setTitle('Gulf Business Development Group');
        this.meta.addTag({ name: 'description', content: 'Gulf Business Development Group (GBDG) was founded in 2013 by an ingenious entrepreneur with a strategic vision to transform Qatar\'s land transportation sector through advanced technological solutions and services, aiming to establish a new benchmark for innovation and progress.' });
        this.meta.addTag({ name: 'keywords', content: ' Gulf Business Development Group,GBDG,Best Technology Company Qatar,Commissioning Services Qatar,GBDG Qatar,Gulf Business Qatar,Qatar Technology Solutions,Supply and Installation Qatar,GBDG Qatar near me,Qatari Company,Business Development Qatar,New Technologies in Qatar,PWA Contractor,Public Works Authority,Ministry of Transportation,Ministry of Interior,PWA Qatar,MoT Qatar,MoI Qatar,Software Qatar,ISO 9001 Certified Company Qatar,ISO 14001 Certified Company Qatar,ISO 45001 Certified Company Qatar,ISO Certified Company Qatar,Trademarks Qatar,Intellectual Properties Qatar,Licenced Contractor Qatar,Congestion Charging Qatar,Intelligent Transportation Systems,ITS Qatar,Road Safety Solutions,Tolling System Qatar,ITS Contractor Qatar,ITS Testing and Commissioning Qatar,DMS Qatar,LCS Qatar,AID Qatar,LPR Qatar,Gantry Qatar,Automation Contractor Qatar,Best System Integrator Qatar,Tunnel SCADA,Tunnel Management System,Top Tunnel Management System in Qatar,Tunnel Management System in Qatar,Tunnel Management System near me,Best PLC & SCADA Automation in Doha,PLC & SCADA Automation,PLC & SCADA Automation in Doha,PLC & SCADA Automation in Qatar,PLC & SCADA Automation near me,Top PLC & SCADA Automation in Doha,SCADA Qatar,SCADA Contractor Qatar,PLC Qatar,RTU Qatar,IoT Qatar,PLC SCADA Qatar,PLC Testing and Commissioning Qatar,Access Control System Qatar,Best ELV System Contractor Qatar,Building Security Qatar,CCTV Contractor Qatar,CCTV System Qatar,Datacenter Solutions Qatar,ICT Contractor Qatar,Security Systems Qatar,Telecom Contractor Qatar,Turnstile System Qatar,Video Surveillance Qatar,ICT and ELV Systems,ICT and ELV Systems in Doha,ICT and ELV Systems in Qatar,ICT and ELV Systems near me,MOI-SSD Certified Qatar,Licensed ICT Contractor,Asset Management Qatar,Asset Management,Asset Management in Qatar,Asset Management near me,Best Asset Management in Doha,Top Asset Management in Qatar,Top Integrated Transportation Solutions in Doha,Top Integrated Transportation Solutions in Qatar,Asset Management Consultancy Qatar,Asset Management Training Qatar,Asset Management Services Qatar,ISO 55001 Qatar,Asset Management Certification Qatar,Asset Information Management Qatar,Asset Performance Management Qatar,Electrical Contractor Qatar,Electrical Maintenance Qatar,Kahramaa Licensed Contractor,Street Lighting Qatar,Electrical Lighting Supply,Electrical Lighting Supply in Doha,Electrical Lighting Supply in Qatar,Electrical Lighting Supply near me,PWA Electrical Contractor Qatar,Lighting Solutions Qatar,Smart Lighting Qatar,PWA Lighting Contractor Qatar,Landscape Lighting Qatar,Building Lighting Qatar,Asset Inventory Survey Qatar,GPR Survey Qatar,LCMS Qatar,Pavement Condition Surveys,Pavement Surveys,Road Condition Surveys,Road Surveys,ROMDAS,Best Road Network Surveys in Doha,Road Network Surveys,Road Network Surveys in Qatar,Road Network Surveys near me,Top Road Network Surveys in Qatar,Road Network Surveys Qatar,Fast Survey Qatar,Automated Survey Qatar,Laser Profilometer Qatar,Laser Foreign Object Detection Qatar,Data Acquisition Qatar,Control Room Operations,O&M Fleet Services,O&M Framework Contractor Qatar,O&M Services Qatar,Operations and Maintenance,Tunnel Framework Contractor Qatar,Tunnel Maintenance Qatar,Tunnel Operations and Maintenance,Tunnel Safety Solutions,Operation & Maintenance Services in Doha,Operation & Maintenance Services in Qatar,Operation & Maintenance Services near me,Emergency Response Qatar,Traffic Diversion Qatar,Traffic Operators Qatar,Road Operations Qatar,Best Integrated Transportation Solutions in Doha,Integrated Transportation Solutions,Integrated Transportation Solutions near me,Intelligent Transportation Systems in Doha,Intelligent Transportation Systems in Qatar,Intelligent Transportation Systems near me,Integrated Transportation Solutions Qatar,Bus iStop Qatar,Bus Shelters Qatar,Bus Stops Qatar,Bus Stations Qatar,Mowasalat Qatar,SILA Qatar,FIFA 2022 Qatar,Expo 2023 Qatar,Asian Cup 2023 Qatar,Papercast Qatar,Passenger Information System Qatar,Passenger Information Displays Qatar,Public Transportation Information Displays Qatar,E-Ink Displays Qatar,ROKID Qatar,Augmented Reality Qatar,Oil and Gas Glasses,Explosion Proof Glasses,ATEX Certified Glasses Qatar,IECEx Certified Glasses Qatar,Bus iStop,Software Development Qatar,GRAMS,Foot iBridge,GFMS,,' });
        this.meta.addTag({ name: 'robots', content: 'all' });
        this.meta.addTag({ name: 'resource-type', content: 'document' });
        this.meta.addTag({ name: 'page-topic', content: 'Gulf Business Development Group' });
        this.meta.addTag({ name: 'clientbase', content: 'Global' });
        this.meta.addTag({ name: 'distribution', content: 'World Wide Web' });
        this.meta.addTag({ name: 'audience', content: 'all' });
        this.meta.addTag({ name: 'rating', content: 'general' });
        this.meta.addTag({ id: 'googlebot', name: 'googlebot', content: 'index, follow' });
        this.meta.addTag({ name: 'expires', content: 'never' });
        this.meta.addTag({ name: 'bingbot', content: ' index, follow ' });
        this.meta.addTag({ name: 'revisit-after', content: 'Daily' });
        this.meta.addTag({ name: 'author', content: 'Gulf Business Development Group' });
        this.meta.addTag({ name: 'HandheldFriendly', content: 'True' });
        this.meta.addTag({ name: 'YahooSeeker', content: 'Index,Follow' });
        this.meta.addTag({ name: 'geo.region', content: 'UAE' });
        this.meta.addTag({ name: 'State', content: 'Qatar' });
        this.meta.addTag({ name: 'City', content: 'Doha' });
        this.meta.addTag({ name: 'subject', content: 'Rated #1 Gulf Business Development Group' });
    }

    ngOnInit(): void {
        this.setCanonicalURL('https://gulfbdgroup.com/');
    }

    setCanonicalURL(url: string) {
        let link: HTMLLinkElement | null = this.doc.querySelector('link[rel="canonical"]') || null;
        if (link) {
            this.renderer.setAttribute(link, 'href', url);
        } else {
            link = this.renderer.createElement('link');
            this.renderer.setAttribute(link, 'rel', 'canonical');
            this.renderer.setAttribute(link, 'href', url);
            this.renderer.appendChild(this.doc.head, link);
        }
    }

    homeSlides: OwlOptions = {
		    /* animateOut: 'slideOutDown',
        animateIn: 'slideInDown', */
        items: 1,
        loop: true,
        autoplay: true,
        dots: false,
        nav: true,
        autoHeight: true,
        autoplaySpeed: 400,
        mouseDrag: false,
        autoplayHoverPause: true,
        navText: [
            "<i class='flaticon-left-arrow'></i>",
            "<i class='flaticon-next-1'></i>"
        ],
        responsive: {
            0: {
                items: 1,
            },
            576: {
                items: 1,
            },
            768: {
                items: 1,
            },
            1200: {
                items: 1,
            }
        }
    }
    teamSlides: OwlOptions = {
		    loop: true,
        margin: 20,
        dots: true,
        autoplay: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
            },
            575: {
                items: 2,
            },
            576: {
                items: 2,
            },
            768: {
                items: 3,
            },
            992: {
                items: 3,
            },
            1200: {
                items: 4,
            }
        }
    }
    clientWrap: OwlOptions = {
        loop:true,
        margin:30,
        nav:false,
        mouseDrag: true,
        items:1,
        dots: false,
        autoHeight: true,
        autoplay: true,
        smartSpeed: 800,
        autoplayHoverPause: true,
        center: false,
        responsive:{
          0:{
            items:1,
            margin: 10,
          },
          576:{
            items:1,
          },
          768:{
            items:2,
            margin: 20,
          },
          992:{
            items:2,
          },
          1200:{
            items:2,
          }
        }
    }

    // Tabs
    currentTab = 'tab1';
    switchTab(event: MouseEvent, tab: string) {
        event.preventDefault();
        this.currentTab = tab;
    }

	// Video Popup
	isOpen = false;
    openPopup(): void {
        this.isOpen = true;
    }
    closePopup(): void {
        this.isOpen = false;
    }

}
